module.exports = __webpack_public_path__ + "img/ai-card-img1.ee107eef.png";